import { useState } from 'react';
import { ChevronsUpDown, HeartPulse, Smartphone } from 'lucide-react';
import Item from './Item';

const PostOpInstructions = ({ postOpInstruction }) => {
  const [openIndexes, setOpenIndexes] = useState([]);

  const { sentAt, sections = [] } = postOpInstruction || {};

  if (!sections.length) return null;

  const allOpen = openIndexes.length === sections.length;

  const toggle = (index) => {
    setOpenIndexes((open) => {
      if (open.includes(index)) return open.filter((i) => i !== index);

      return [...open, index];
    });
  };

  return (
    <div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
      <div className="p-5">
        <div className="flex flex-wrap items-start gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-blue-50">
            <HeartPulse size={20} className="text-teamcare-blue" />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="text-lg font-bold text-secondary-900">Post-op instructions</h3>
            <p className="mt-1 flex items-center gap-1.5 text-sm text-secondary-500">
              <Smartphone size={14} className="shrink-0" />
              Sent by text on {sentAt}
            </p>
          </div>

          {sections.length > 1 && (
            <button
              type="button"
              onClick={() => setOpenIndexes(allOpen ? [] : sections.map((_, i) => i))}
              className="btn h-10 min-h-0 basis-full rounded-xl border-gray-200 bg-white px-4 text-sm font-semibold text-secondary-900 hover:bg-gray-50 sm:basis-auto"
            >
              <ChevronsUpDown size={16} />
              {allOpen ? 'Collapse all' : 'Expand all'}
            </button>
          )}
        </div>

        <p className="mt-4 text-sm text-secondary-600">Your care team sent these after your visit. Select one to read it.</p>

        <div className="mt-3 space-y-3">
          {sections.map((item, index) => (
            <Item key={index} item={item} open={openIndexes.includes(index)} onToggle={() => toggle(index)} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PostOpInstructions;
